import { Trash2, StopCircle } from 'lucide-react'
import { Button } from '@components/ui/button'

const formatCounter = (seconds) => `0:${seconds.toString().padStart(2, '0')}`

const AudioRecorder = ({ cancelRecording, stopRecording, secondsRecorded }) => {
  return (
    <div className='w-full flex items-center justify-start h-min-[40px] p-3'>
      <Button
        variant="ghost"
        size="icon"
        aria-label='Cancel recording'
        onClick={cancelRecording}
        className='mr-3 hover:bg-transparent p-1 rounded-full'
        type='button'
      >
        <Trash2 className='size-6' />
      </Button>

      <div className='flex rounded-full items-center bg-muted px-3 py-1'>
        <div className='w-3 h-3 bg-red-500 rounded-full mr-2 animate-pulse' />
        <p className='leading-none tabular-nums'>
          {formatCounter(secondsRecorded)}
        </p>
      </div>

      <div className='flex ml-auto items-center'>
        <Button
          variant="ghost"
          size="icon"
          onClick={stopRecording}
          className='focus-visible:ring-1 group ml-auto p-1 rounded-full'
          type='button'
          aria-label="Stop recording"
        >
          <StopCircle className='size-8 text-red-600' />
        </Button>
      </div>
    </div>
  )
}

export default AudioRecorder
